import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';
import { ServiceProcessFlag, ServiceProcessFlagUpdateRequest } from '../../_models/admin/service-process.models';

/**
 * Typed calls to the service process switch endpoints (api/Maintenance/Processes...).
 *
 * Follows the shared BaseService pattern. prepareOptions() hashes
 * JSON.stringify(payload).toLowerCase() into the RequestMatch header, so the object passed to
 * prepareOptions MUST be the exact object sent as the request body — wrapping it hashes a different
 * shape and the API returns 403. GETs send no body and use prepareOptions(null). prepareOptions()
 * also sets observe:'response', so every response is unwrapped via unwrap().
 */
@Injectable({ providedIn: 'root' })
export class ServiceProcessService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
  ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith('/') ? '' : '/';
  }

  public getProcesses(): Observable<ServiceProcessFlag[]> {
    return this.http.get(this.apiUrl + 'api/Maintenance/Processes', this.prepareOptions(null)).pipe(
      map((data: any) => this.unwrap(data) as ServiceProcessFlag[]),
      catchError(this.handleError('getProcesses'))
    );
  }

  public setProcess(request: ServiceProcessFlagUpdateRequest): Observable<any> {
    return this.http.post(this.apiUrl + 'api/Maintenance/Processes/Set', request, this.prepareOptions(request)).pipe(
      map((data: any) => this.unwrap(data)),
      catchError(this.handleError('setProcess'))
    );
  }

  /** Shared body unwrap — prepareOptions() observes the full response, not just the body. */
  private unwrap(data: any): any {
    return data ? data.body : data;
  }
}
